import api from '../../../../services/api';
import {
  setShopifyStores,
  setLoading,
  setError
} from '../reducers';

// Fetch all Shopify stores
export const fetchShopifyStores = () => async (dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await api.get('/shopify/stores');
    dispatch(setShopifyStores(response.data.data || []));
  } catch (error) {
    console.error('Error fetching Shopify stores:', error);
    dispatch(setError('Không thể lấy danh sách Shopify stores'));
  } finally {
    dispatch(setLoading(false));
  }
};

// Create new Shopify store
export const createShopifyStore = (storeData) => async (dispatch) => {
  try {
    await api.post('/shopify/stores', storeData);
    dispatch(fetchShopifyStores());
    return { success: true, message: 'Tạo Shopify store thành công' };
  } catch (error) {
    return { success: false, message: 'Lỗi khi tạo Shopify store' };
  }
};

// Update Shopify store
export const updateShopifyStore = (id, storeData) => async (dispatch) => {
  try {
    await api.put(`/shopify/stores/${id}`, storeData);
    dispatch(fetchShopifyStores());
    return { success: true, message: 'Cập nhật Shopify store thành công' };
  } catch (error) {
    return { success: false, message: 'Lỗi khi cập nhật Shopify store' };
  }
};

// Delete Shopify store
export const deleteShopifyStore = (id) => async (dispatch) => {
  try {
    await api.delete(`/shopify/stores/${id}`);
    dispatch(fetchShopifyStores());
    return { success: true, message: 'Xóa Shopify store thành công' };
  } catch (error) {
    return { success: false, message: 'Lỗi khi xóa Shopify store' };
  }
};

// Test Shopify store connection
export const testShopifyConnection = (id) => async () => {
  try {
    const response = await api.post(`/shopify/stores/${id}/test-connection`);
    return { success: true, message: 'Kết nối Shopify thành công', data: response.data };
  } catch (error) {
    return { success: false, message: 'Lỗi khi kết nối Shopify' };
  }
};
